const c = {
  name: "LanguageLocalization",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,19.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.7,18.7,19.3,19.2,20,19.2z"
			/>
		<path class="st0" d="M21.2,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,12.7,21.2,13.3,21.2,14z"
			/>
		<path class="st0" d="M20,23.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.7,22.7,19.3,23.2,20,23.2z"
			/>
		<path class="st0" d="M21.2,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,24.7,21.2,25.3,21.2,26z"
			/>
		<path class="st0" d="M26,19.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.7,18.7,25.3,19.2,26,19.2z"
			/>
		<path class="st0" d="M26,23.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.7,22.7,25.3,23.2,26,23.2z"
			/>
		<path class="st0" d="M23,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C21.7,20.7,22.3,21.2,23,21.2z"
			/>
		<path class="st0" d="M24.2,16c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C23.7,14.7,24.2,15.3,24.2,16z"
			/>
		<path class="st0" d="M24.2,24c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C23.7,22.7,24.2,23.3,24.2,24z"
			/>
		<path class="st0" d="M18.2,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C17.7,18.7,18.2,19.3,18.2,20z"
			/>
		<path class="st0" d="M17,17.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C15.7,16.7,16.3,17.2,17,17.2z"
			/>
		<path class="st0" d="M20,10c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10C30,14.5,25.5,10,20,10z M26.4,15.2
			c1,1.3,1.6,3,1.6,4.8c0,1.8-0.6,3.5-1.6,4.8c-0.1,0-0.3-0.1-0.4-0.1c-0.7,0-1.2,0.6-1.2,1.2c0,0.1,0,0.3,0.1,0.4
			c-0.3,0.2-0.7,0.5-1,0.6c-0.2-0.2-0.5-0.3-0.8-0.3c-0.6,0-1.1,0.5-1.2,1.1C21.2,27.9,20.6,28,20,28c-4.4,0-8-3.6-8-8s3.6-8,8-8
			c0.6,0,1.2,0.1,1.8,0.2c0.1,0.6,0.6,1.1,1.2,1.1c0.3,0,0.6-0.1,0.8-0.3c0.4,0.2,0.7,0.4,1,0.6c0,0.1-0.1,0.3-0.1,0.4
			c0,0.7,0.6,1.2,1.2,1.2C26.1,15.2,26.3,15.2,26.4,15.2z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20c0,11-9,20-20,20c-4.1,0-7.8-1.2-11-3.3l-8.6,2.9L3.3,31
			C1.2,27.8,0,24.1,0,20z M20,2C10.1,2,2,10.1,2,20c0,3.8,1.2,7.3,3.2,10.2l0.3,0.4l-1.9,5.8l5.8-1.9l0.4,0.3
			c2.9,2,6.4,3.2,10.2,3.2c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as LanguageLocalization
};
